@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>{{ id === '0' ? 'New Product Option' : 'Edit Product Option' }}</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Product options are a global list for this venue. Once created they can be attached to individual products.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label class="font-medium">Option Name</label>
            <input [(ngModel)]="Option.name"
              type="text"
              pInputText
              [ngStyle]="{'border-color': optionNameValid ? '' : '#FF0000'}"
              (keyup)="doValidCheck()">
              @if (!optionNameValid) {
                <div class="text-danger" style="margin-top:4px;">
                  <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an option name.
                </div>
              }
            </div>
            <div class="field mb-4 col-12">
              <label class="font-medium">Price</label><br/>
              <p-inputnumber [(ngModel)]="Option.price"
                mode="currency"
                currency="{{ CurrencySymbol }}"
                locale="en-GB"
                [min]="0"
                [max]="9999">
              </p-inputnumber>
            </div>
            <div class="field mb-4 col-12">
              <label class="font-medium">Status</label>
              <div style="margin-top:6px;">
                <p-selectbutton [options]="enabledOptions"
                  [(ngModel)]="Option.disabled"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{'width': '200px'}">
                </p-selectbutton>
              </div>
            </div>
            <div class="col-12">
              <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData()">
                <span class="pi pi-pencil" style="margin-right:8px;"></span>Save Changes
              </button>
              &nbsp;
              <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                <span class="pi pi-times" style="margin-right:8px;"></span>Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
